// -*- coding: utf-8 -*-
import { apiUrl, fetchJson } from '../../apiBase';

export async function listThemes(school) {
  const url = apiUrl(`/admin/values/themes/${encodeURIComponent(school)}`);
  const res = await fetchJson(url);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function getTheme(school, themeId) {
  const url = apiUrl(`/admin/values/themes/${encodeURIComponent(school)}/${encodeURIComponent(themeId)}`);
  const res = await fetchJson(url);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function saveTheme(school, payload, isUpdate = false) {
  const path = isUpdate
    ? `/admin/values/themes/${encodeURIComponent(school)}/${encodeURIComponent(payload.id)}`
    : `/admin/values/themes/${encodeURIComponent(school)}`;
  const res = await fetchJson(apiUrl(path), {
    method: isUpdate ? 'PUT' : 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function deleteTheme(school, themeId) {
  const url = apiUrl(`/admin/values/themes/${encodeURIComponent(school)}/${encodeURIComponent(themeId)}`);
  const res = await fetchJson(url, { method: 'DELETE' });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function getValueTemplates() {
  const url = apiUrl('/admin/values/templates');
  const res = await fetchJson(url);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

// Programs (schedule)
export async function listValuePrograms(school) {
  const url = apiUrl(`/admin/values/programs/${encodeURIComponent(school)}`);
  const res = await fetchJson(url);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function saveValueProgram(school, payload) {
  const url = apiUrl(`/admin/values/programs/${encodeURIComponent(school)}`);
  const res = await fetchJson(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function deleteValueProgram(school, programId) {
  const url = apiUrl(`/admin/values/programs/${encodeURIComponent(school)}/${encodeURIComponent(programId)}`);
  const res = await fetchJson(url, { method: 'DELETE' });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function listEvaluationResults(school, { theme_id, program_id, schedule_id, student_id, class_id } = {}) {
  const params = new URLSearchParams();
  if (theme_id) params.set('theme_id', theme_id);
  if (program_id) params.set('program_id', program_id);
  if (schedule_id) params.set('schedule_id', schedule_id);
  if (student_id) params.set('student_id', student_id);
  if (class_id) params.set('class_id', class_id);
  const qs = params.toString() ? `?${params.toString()}` : '';
  const url = apiUrl(`/admin/values/evaluations/${encodeURIComponent(school)}${qs}`);
  const res = await fetchJson(url);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function getEvaluationResultDetail(school, evaluationId) {
  const url = apiUrl(
    `/admin/values/evaluations/${encodeURIComponent(school)}/${encodeURIComponent(evaluationId)}`
  );
  const res = await fetchJson(url);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}
